export default function () {
  return {
    promociones: null,   
  };
}
